import React from "react";
import { connect } from "react-redux";
import { PageTabs } from "../../../../../../store/AppDisplays";
import { Filter } from "../../../02-pages/Filter";
import * as InvoiceTypes from "../../../../../../store/CollectiveInvoice/Types";
import { isRemoteLoading, ReduxState } from "../../../../../../store/ReduxState";
import { Results } from "../../../02-pages/Results";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

interface OwnProps {
    partnerId: string;
}

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: InvoiceTypes.CollectiveInvoices;
}

type Props = OwnProps & StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.COLLECTIVE_INVOICE_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.COLLECTIVE_INVOICE_RESULTS),
});

/**
 *
 * @param props
 */
export class InvoicesComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <Div style={{marginTop: "-20px"}}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.PARTNER_COLLECTIVEINVOICE}
                    defaultFilters={{
                        partnerId: this.props.partnerId,
                    }}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.PARTNER_COLLECTIVEINVOICE}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const Invoices = connect(
    mapStateToProps,
    {},
)(InvoicesComp);
